"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MediumGroupManager = (function () {
    function MediumGroupManager(oldGroups, groupField) {
        this._mediumGroups = oldGroups;
        if (!groupField) {
            return;
        }
        this._mediumGroups = this.regroupMediumGroups(this.flattenMediumGroups(), groupField);
    }
    Object.defineProperty(MediumGroupManager.prototype, "mediumGroups", {
        get: function () {
            return this._mediumGroups;
        },
        enumerable: true,
        configurable: true
    });
    MediumGroupManager.prototype.flattenMediumGroups = function () {
        var result = new Array();
        this._mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                result.push(placement);
            });
        });
        return result;
    };
    MediumGroupManager.prototype.regroupMediumGroups = function (flatGroups, groupField) {
        var filteredData = _.groupBy(flatGroups, function (candidate) {
            return _.get(candidate, groupField);
        });
        var result = new Array();
        for (var key in filteredData) {
            if (filteredData.hasOwnProperty(key)) {
                var value = filteredData[key];
                result.push({ mediumGroup: value, groupTitle: key });
            }
        }
        return result;
    };
    return MediumGroupManager;
}());
exports.MediumGroupManager = MediumGroupManager;
//# sourceMappingURL=MediumGroupManager.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/MediumGroupManager.js
// module id = 57
// module chunks = 0